import React, { Component } from 'react';
import { useTranslator, withTranslator } from 'static/script/app/lang';
import { Analytics } from 'packages';
import { BankIdModal } from 'tradera-components/bank-id';
import { startAuthAndOpenModal } from 'tradera-state/bank-id/actions';
import { connect } from 'react-redux';
import cookieUtil from 'tradera-utils/cookie';
import { BANK_ID_ALERT_DISMISSED } from 'tradera-constants/cookies';
import { cache, CACHE_KEYS } from 'tradera-utils/cache';
import ProfileMenuBankIdModal from './profile-menu-bank-id-modal';
import CheckIcon from '@tradera/blueprint/theme/icons2/check.svg?jsx';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import PenIcon from '@tradera/blueprint/theme/icons2/pen.svg?jsx';
import SwishIcon from '@tradera/blueprint/theme/icons/swish.svg?jsx';
import UserFillIcon from '@tradera/blueprint/theme/icons2/user-fill.svg?jsx';
import WarningIcon from '@tradera/blueprint/theme/icons/warning.svg?jsx';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';

const trackPaymentOnboarding = (action, label) => {
    Analytics.trackEvent({
        category: 'Tradera Payment Onboarding',
        action: action,
        label: label
    });
};

const trackBankIdModal = label => {
    Analytics.trackEvent({
        category: 'User Profile',
        action: 'BankID Test',
        label: label
    });
};

const InvoiceUnpaidAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert alert-warning d-flex mx-3 my-2 text-hyphenate">
            <InfoIcon className="icon mr-2 flex-shrink-0" />
            <span>
                <strong>{t('siteheader_invoiceUnpaidTitle')}</strong>
                <br />
                {t('siteheader_invoiceUnpaidDescription')}
            </span>
        </div>
    );
};

const InvoiceOverdueAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert alert-danger d-flex mx-3 my-2 text-hyphenate">
            <WarningIcon className="icon mr-2 flex-shrink-0" />
            <span>
                <strong>{t('siteheader_invoiceOverdueTitle')}</strong>
                <br />
                {t('siteheader_invoiceOverdueDescription')}
            </span>
        </div>
    );
};

const BankAccountMissingAlert = () => {
    const { t } = useTranslator();
    trackPaymentOnboarding(
        'Bank account Onboarding Alert',
        'Will add from - Account menu alert'
    );
    return (
        <div className="alert alert-warning d-flex mx-3 my-2 text-hyphenate">
            <InfoIcon className="icon mt-1 mr-2 flex-shrink-0" />
            <span>
                <strong>{t('siteheader_bankAccountMissingTitle')}</strong>
                <br />
                {t('siteheader_bankAccountMissingDescription')}
            </span>
        </div>
    );
};

const PayoutFailedAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert alert-danger d-flex mx-3 my-2 text-hyphenate">
            <WarningIcon className="icon mt-1 mr-2 flex-shrink-0" />
            <span>
                <strong>{t('siteheader_payoutFailedTitle')}</strong>
                <br />
                {t('siteheader_payoutFailedDescription')}
            </span>
        </div>
    );
};

const PayoutReadyBankAccountMissingAlert = () => {
    const { t } = useTranslator();
    trackPaymentOnboarding(
        'Bank account Onboarding Alert',
        'Will add from - Account menu alert - Failed payment'
    );
    return (
        <div className="alert alert-danger d-flex flex-column mx-3 my-2 text-hyphenate">
            <div className="d-flex">
                <WarningIcon className="icon mt-1 mr-2 flex-shrink-0" />
                <span>
                    <strong>
                        {t('siteheader_paymentReadBankAccountMissingTitle')}
                    </strong>
                    <br />
                    {t('siteheader_paymentReadBankAccountMissingDescription')}
                </span>
            </div>
        </div>
    );
};

const SwishMissingAlert = ({ dismissSwish, enableSwishUrl }) => {
    const { t } = useTranslator();
    trackPaymentOnboarding(
        'Swish Onboarding Alert',
        'Show on - Account menu alert'
    );
    return (
        <div className="alert alert-danger d-flex flex-column mx-3 my-2 text-hyphenate">
            <div className="d-flex">
                <SwishIcon className="icon mt-1 mr-2 flex-shrink-0" />
                <span>
                    <strong>{t('siteheader_swishMissingTitle')}</strong>
                    <br />
                    {t('siteheader_swishMissingDescription')}
                </span>
            </div>
            <button
                className="btn btn-outline-light btn--icon-fixed btn-fluid mt-3"
                onClick={() => {
                    location.href = enableSwishUrl;
                    trackPaymentOnboarding(
                        'Swish Onboarding Alert',
                        'Will add from - Account menu alert'
                    );
                }}>
                <PenIcon className="icon icon-before" />
                {t('siteheader_addSwish')}
            </button>
            <button
                className="btn btn-outline-light mt-3"
                onClick={() => {
                    {
                        dismissSwish;
                    }
                    trackPaymentOnboarding(
                        'Swish Onboarding Alert',
                        'Dismissed from - Account menu alert'
                    );
                }}>
                {t('siteheader_swishNoThanks')}
            </button>
        </div>
    );
};

const HyperwalletPayeeVerificationAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert alert-danger d-flex flex-column mx-3 my-2 text-hyphenate">
            <div className="d-flex">
                <WarningIcon className="icon mt-1 mr-2 flex-shrink-0" />
                <span>
                    <strong>
                        {t('siteheader_hyperwalletPayeeVerificationTitle')}
                    </strong>
                    <br />
                    {t('siteheader_hyperwalletPayeeVerificationDescription')}
                </span>
            </div>
            <button
                className="btn btn-outline-light btn--icon-fixed btn-fluid mt-3"
                onClick={e => {
                    e.preventDefault();
                    location.href = '/my/PayeeVerification';
                }}>
                {t('siteheader_hyperwalletPayeeVerificationMoreInfo')}
            </button>
        </div>
    );
};

const HyperwalletPayeeVerificationReviewAlert = () => {
    const { t } = useTranslator();
    return (
        <div
            className="alert alert-warning d-flex mx-3 my-2 text-hyphenate"
            onClick={e => {
                e.preventDefault();
                location.href = '/my/PayeeVerificationCompleted';
            }}>
            <WarningIcon className="icon mt-1 mr-2 flex-shrink-0" />
            <span>
                <strong>
                    {t('siteheader_hyperwalletPayeeVerificationReviewTitle')}
                </strong>
                <br />
                {t('siteheader_hyperwalletPayeeVerificationReviewDescription')}
            </span>
        </div>
    );
};

class BankIdVerificationAlertConnected extends Component {
    constructor(props) {
        super(props);
        const hideAlert =
            cookieUtil.readCookie(BANK_ID_ALERT_DISMISSED) === 'true';
        this.state = {
            modalOpen: false,
            hideAlert
        };
    }

    componentDidMount() {
        trackBankIdModal('Alert displayed');
    }

    onBankIdComplete = () => {
        trackBankIdModal('Verified - Successfully');
        cache.remove(CACHE_KEYS.SYSTEM_MESSAGES);
        this.setState({
            modalOpen: false,
            hideAlert: true
        });
    };

    onBankIdError = () => {
        trackBankIdModal('Verified - Failed');
    };

    onBackIdClose = () => {
        this.setState({
            modalOpen: false
        });
    };

    onDismissBankId = () => {
        const cookieName = BANK_ID_ALERT_DISMISSED;
        const expireDate = new Date();
        const value = true;
        expireDate.setTime(expireDate.getTime() + 10 * 60 * 1000);
        cookieUtil.createCookie(cookieName, value, expireDate);
        this.setState({
            hideAlert: true
        });
    };

    trackAndStartAuthAndOpenModal = () => {
        const { openBankIdModal } = this.props;
        this.setState({
            modalOpen: 'bank-modal'
        });
        openBankIdModal(this.onBankIdComplete, this.onBankIdError);
    };

    showFirstModal = () => {
        trackBankIdModal('User Accepted');
        this.setState({
            modalOpen: 'first-modal'
        });
    };

    closeFirstModal = () => {
        this.setState({
            modalOpen: false
        });
    };

    showBankIdModal = () => {
        this.setState({
            modalOpen: 'bank-modal'
        });
    };

    render() {
        const { t } = this.props;
        const { modalOpen, hideAlert } = this.state;
        if (hideAlert) {
            return null;
        }
        return (
            <div className="alert alert-danger d-flex flex-column mx-3 my-2 px-2 text-hyphenate">
                <div>
                    <UserFillIcon className="icon align-text-bottom mr-2" />
                    <span>
                        <strong>Din profil är 80% komplett</strong>
                    </span>
                </div>
                <div className="d-flex flex-column mx-4">
                    <div>
                        <CheckIcon className="icon align-text-bottom mr-2" />
                        <span>{t('verify_AlertName')}</span>
                    </div>
                    <div>
                        <CheckIcon className="icon align-text-bottom mr-2" />
                        {t('verify_AlertPhoneNumber')}
                    </div>
                    <div>
                        <CheckIcon className="icon align-text-bottom mr-2" />
                        {t('verify_AlertAddress')}
                    </div>
                    <div>
                        <CheckIcon className="icon align-text-bottom mr-2" />
                        {t('verify_AlertEmail')}
                    </div>
                    <div style={{ marginLeft: '21px' }}>
                        {t('verify_AlertBankId')}
                    </div>
                    <button
                        className="btn btn-outline-light btn--icon-fixed btn-fluid mt-3"
                        onClick={() => {
                            this.showFirstModal();
                        }}>
                        {t('verify_AlertAccept')}
                    </button>
                    <button
                        className="btn btn-outline-light btn--icon-fixed btn-fluid mt-3"
                        onClick={() => {
                            trackBankIdModal('User Rejected');
                            this.onDismissBankId();
                        }}>
                        <CloseIcon className="icon icon-before" />
                        {t('verify_AlertCancel')}
                    </button>
                </div>
                {modalOpen === 'bank-modal' ? (
                    <BankIdModal onClose={this.onBackIdClose} />
                ) : null}
                {modalOpen === 'first-modal' ? (
                    <ProfileMenuBankIdModal
                        onVerifyWithBankId={this.trackAndStartAuthAndOpenModal}
                        onCloseAction={this.closeFirstModal}
                        onDismissAction={this.onDismissBankId}
                    />
                ) : null}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        openBankIdModal: (onBankIdComplete, onBankIdError) =>
            dispatch(startAuthAndOpenModal(onBankIdComplete, onBankIdError))
    };
};

const BankIdVerificationAlert = connect(
    null,
    mapDispatchToProps
)(withTranslator(BankIdVerificationAlertConnected));

export {
    InvoiceUnpaidAlert,
    InvoiceOverdueAlert,
    BankAccountMissingAlert,
    PayoutFailedAlert,
    PayoutReadyBankAccountMissingAlert,
    SwishMissingAlert,
    HyperwalletPayeeVerificationAlert,
    HyperwalletPayeeVerificationReviewAlert,
    BankIdVerificationAlert
};
